import axios from '../axios'
import { Weather } from '../helpers/types/weather'

export const fetchWeather = async () => {
	const { data } = await axios.get(`/api/v1/weather`)
	return data as Weather[]
}
